// identifiers for subtotaling
export const PRODUCT_IDENTIFIER = 'product';
export const SHIPPING_IDENTIFIER = 'shipping';

// tax aggregation level
export const ORDER_LEVEL = 'order';
export const ITEM_LEVEL = 'item';
export const ITEM_GROUP_LEVEL = 'itemGroup';
export const SHIPPING_LEVEL = 'shipping';

// tax display format type
export const DEFAULT_TAX_DISPLAY = 'default';
export const DETAILED_TAX_DISPLAY = 'detailed';
